// import DonateModal from "../DonateModal";
import { MolhamSingleTargetable, TMyEventsItem } from "apiTypes";
import TargetableSlider from "components/Home/TargetableSlider";
import EditEventModal from "components/Profile/EditEventModal";
import { AUTH_URL } from "config";
import useModal from "customHooks/useModal";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getData } from "utils/getData";
import { postData } from "utils/postData";
import DonateControlBar from "./DonateControlBar";
import ImageTitle from "./ImageTitle";
import TargetableTabs from "./TargetableTabs";

type Props = {
  url: {
    endPoint: string;
    id: string;
    query: string;
  };
  data: MolhamSingleTargetable;
  sectionName: string;
};

const TargetablePage = ({ url, data: singleCase, sectionName }: Props) => {
  const { contents, id, created_by_auth } = singleCase;
  const { t } = useTranslation("common");
  const [item, setItem] = useState<null | TMyEventsItem>(null);
  const router = useRouter();
  const hideReqAndPB = router.asPath.includes("events/3165");
  // const hideReqAndPB = false;
  const {
    showModal: showEditEventModal,
    handleCloseModal: handleCloseEditEventModal,
    handleShowModal: handleShowEditEventModal,
  } = useModal();
  const onEventSubmit = async (data) => {
    const Obj = {
      title: data.title,
      details: data.details,
      ...(data.preview_image ? { preview_image: data.preview_image } : null),
      private: data.private ? 1 : 0,
      purpose_id: data?.category_id,
    };

    let form_data = new FormData();

    for (let key in Obj) {
      form_data.append(key, Obj[key]);
    }

    try {
      const res = await postData(
        `${AUTH_URL}/events/${singleCase.id}`,

        form_data,
        null,
        { "Content-type": "multipart/form-data" },
      );

      if (res.data?.error) {
        toast.error(res.data?.error);
        return;
      }

      toast.success(t(`event_add_title`));
      //refresh the page
      window.location.reload();
    } catch (err) {
      if (err?.response?.data.status === "Unauthorized") {
        toast.error(err.response.data.status);

        return;
      }

      toast.error(err?.message);

      toast.error(err.response?.data.error?.code);
    }
  };
  useEffect(() => {
    getData(`${AUTH_URL}/events`).then((res) => {
      const data = res.data.data as TMyEventsItem[];
      setItem(data.find((item) => item.id === singleCase.id));
    });
  }, [created_by_auth]);
  const hasVid =
    sectionName.includes("campaign") &&
    ["630", "724", "670", "751", "831", "818"].includes(id.toString());

  return (
    <>
      <EditEventModal
        onFormSubmit={onEventSubmit}
        showEditEventModal={showEditEventModal}
        handleCloseEditEventModal={handleCloseEditEventModal}
        // selectedItem={singleCase as unknown as TMyEventsItem}
        selectedItem={item}
      />
      <TargetableSlider
        images={singleCase?.preview_images}
        title={contents?.title}
        hasVidId={hasVid ? id.toString() : null}
        id={id.toString()}
      />
      <div className="px-3 px-lg-0">
        <ImageTitle
          // id={id}
          editable={created_by_auth}
          title={contents?.title}
          onEditEventClick={handleShowEditEventModal}
          shortName={contents?.short_name}
          // description={contents?.description}
          required_amount={singleCase?.required_amount}
          noReqAmount={hideReqAndPB}
        />

        <DonateControlBar
          singleCase={singleCase}
          sectionName={sectionName}
          noProgressBar={hideReqAndPB}
        />
      </div>

      <TargetableTabs url={url} singleCase={singleCase} />
    </>
  );
};

export default TargetablePage;
